export default __webpack_public_path__ + "dist/media/Check-white.4389473a.svg";